var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-card card-shadow",attrs:{"outlined":""}},[_c('v-card-text',{staticClass:"text--primary px-6 pt-8"},[_c('px-acompanhamentos',{attrs:{"allow-files":"","is-marketplace":"","disabled":"","item-type":_vm.messageType,"item-id":_vm.compra.id,"user":_vm.user},on:{"on-message":_vm.onMessage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }